// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {useEffect, Dispatch, useCallback, useState, useRef} from 'react';
import etask from 'zetask';
import {SESSION_ACTIONS, t_session_action} from './sessions_reducer';
import {api} from '../api';
import {fake_project} from './utils';

interface i_api_response {
    sessions?: any[];
    results?: Record<string, any[]>;
    error?: string;
}

export const use_sessions_polling = (
    dispatch: Dispatch<t_session_action>,
    zone_id?: string)=>
    {
    const [interval, set_interval] = useState<number>(null);
    const fetch_timer = useRef<ReturnType<typeof setInterval>>();
    const fetch_sessions = useCallback((_zone_id?: string)=>{
        const id = _zone_id || zone_id;
        if (!id)
            return;
        return etask(function*(){
            try {
                const data: i_api_response = yield api.get_zone_sessions(id);
                const {sessions = [], results = {}, error} = data ?? {};
                dispatch({
                    type: SESSION_ACTIONS.SET_SESSIONS,
                    payload: {sessions, results, error}
                });
            } catch(e: any){
                dispatch({
                    type: SESSION_ACTIONS.SET_ERROR,
                    payload: e.message || 'Failed to fetch sessions'
                });
                dispatch({type: SESSION_ACTIONS.SET_BUSY, payload: false});
            }
        });
    }, [zone_id]);
    useEffect(()=>{
        if (!zone_id || zone_id === fake_project._id || interval === null)
            return;
        dispatch({type: SESSION_ACTIONS.SET_BUSY, payload: true});
        dispatch({type: SESSION_ACTIONS.SET_ERROR, payload: null});
        fetch_sessions();
        fetch_timer.current = setInterval(fetch_sessions, interval);
        return ()=>{
            if (fetch_timer.current)
                clearInterval(fetch_timer.current);
        };
    }, [zone_id, interval, fetch_sessions]);
    const update_interval = useCallback((new_interval: number)=>{
        set_interval(new_interval);
    }, []);
    return {
        fetch_sessions,
        update_interval,
    };
};
